(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["anderst-kombi-offer"] && !Shopify.designMode) return;
  try {
    (() => {
  const configElement = document.getElementById('AnderstKombiConfig');
  const dialog = document.getElementById('AnderstKombiDialog');
  if (!configElement || !dialog || typeof dialog.showModal !== 'function') return;
  const config = JSON.parse(configElement.textContent);
  const strings = config.strings;
  const eligible = new Set();
  let catalogPromise;
  let catalog;
  let currentCart;
  let currentLine;
  let pendingAction;
  let busy = false;
  let bypass = false;
  let restoreDrawer = false;
  let updating = false;
  let decisions = {};
  try { decisions = JSON.parse(sessionStorage.getItem('anderst-kombi-v1') || '{}'); } catch {}
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'de-CH', {style:'currency',currency:'CHF'}).format(cents / 100);
  const cartKey = cart => String(cart.token || '').split('?')[0];
  const remember = cart => {
    decisions = { [cartKey(cart)]: true };
    try { sessionStorage.setItem('anderst-kombi-v1', JSON.stringify(decisions)); } catch {}
  };
  const getJSON = async (url, options = {}) => {
    const response = await fetch(url, {credentials:'same-origin', cache:'no-store', signal:AbortSignal.timeout(8000), ...options});
    const data = await response.json();
    if (!response.ok || data.errors) throw new Error(data.description || strings.error);
    return data;
  };
  const loadCatalog = () => catalogPromise ||= getJSON(config.catalog,{cache:'force-cache'}).then(data => {
    catalog = data;
    data.eligibleIds.forEach(id => eligible.add(String(id)));
    return data;
  }).catch(error => { catalogPromise = null; throw error; });
  const readCart = () => getJSON(root + 'cart.js');
  const hasCase = cart => cart.items.some(item => catalog.caseTypes.includes(item.product_type) || catalog.extraCaseIds.includes(String(item.product_id)));
  const hasBundle = cart => cart.items.some(item => eligible.has(String(item.variant_id)) && item.quantity > 0);
  const missingLine = cart => cart.items.find(item => catalog.without[String(item.variant_id)] && item.quantity > 0);
  const allowed = cart => cart.currency === 'CHF' && hasCase(cart);
  const termsAccepted = button => {
    const checkbox = document.getElementById(button?.closest('cart-drawer') || button?.id === 'CartDrawer-Checkout' ? 'agb-terms-checkbox-mini' : 'agb-terms-checkbox');
    return !checkbox || checkbox.checked;
  };
  const checkoutButton = () => document.querySelector('cart-drawer.active [name="checkout"]') || document.getElementById('checkout') || document.getElementById('CartDrawer-Checkout');
  const resume = action => {
    if (!action) return;
    bypass = true;
    try {
      const button = action.button?.isConnected ? action.button : document.getElementById(action.button?.id);
      if (action.kind === 'submit' && action.form?.isConnected) action.form.requestSubmit(button || undefined);
      else if (button) button.click();
    } finally { bypass = false; }
  };
  const close = () => {
    dialog.close();
    if (restoreDrawer) {
      const drawer = document.querySelector('cart-drawer');
      drawer?.open?.();
    }
    restoreDrawer = false;
  };
  const open = () => {
    const drawer = document.querySelector('cart-drawer.active');
    restoreDrawer = Boolean(drawer);
    drawer?.close?.();
    dialog.showModal();
  };
  const setView = view => {
    dialog.querySelectorAll('[data-kombi-view]').forEach(element => { element.hidden = element.dataset.kombiView !== view; });
    dialog.querySelector('[data-kombi-error]').textContent = '';
  };
  const showOffer = cart => {
    currentCart = cart;
    currentLine = missingLine(cart);
    setView('offer');
    dialog.querySelector('[data-kombi-title]').textContent = currentLine ? strings.missing_title : strings.title;
    dialog.querySelector('[data-kombi-description]').textContent = currentLine ? strings.missing_body : strings.body;
    dialog.querySelector('[data-kombi-accept]').textContent = currentLine ? strings.choose_adapter : strings.choose_band;
    open();
  };
  const selectedChoice = () => {
    const value = dialog.querySelector('[name="kombi_adapter"]:checked')?.value;
    return catalog.without[String(currentLine.variant_id)].choices.find(choice => choice.id === value);
  };
  const updateChoice = () => {
    const choice = selectedChoice();
    const condition = dialog.querySelector('[data-kombi-metal-confirm]');
    const checkbox = condition.querySelector('input');
    condition.hidden = choice.fabric;
    checkbox.required = !choice.fabric;
    checkbox.checked = false;
    const extra = choice.price - catalog.without[String(currentLine.variant_id)].price;
    dialog.querySelector('[data-kombi-price]').textContent = strings.price.replace('[adapter]',money(extra)).replace('[extra]',money(extra - 500));
  };
  const showAdapters = () => {
    setView('adapters');
    const band = catalog.without[String(currentLine.variant_id)];
    dialog.querySelector('[data-kombi-band]').textContent = band.title;
    const choices = dialog.querySelector('[data-kombi-choices]');
    choices.replaceChildren();
    band.choices.forEach((choice,index) => {
      const label = document.createElement('label');
      label.className = 'anderst-kombi-choice';
      const radio = document.createElement('input');
      radio.type = 'radio'; radio.name = 'kombi_adapter'; radio.value = choice.id; radio.checked = index === 0;
      radio.addEventListener('change',updateChoice);
      const text = document.createElement('span');
      text.textContent = choice.fabric ? strings.fabric : choice.label + ' · ' + strings.metal;
      radio.setAttribute('aria-label',text.textContent + (choice.fabric ? ' · ' + strings.recommended : ''));
      label.append(radio,text);
      if (choice.fabric) { const badge = document.createElement('strong'); badge.textContent = strings.recommended; label.append(badge); }
      choices.append(label);
    });
    updateChoice();
    choices.querySelector('input')?.focus();
  };
  const refreshHints = async () => {
    try {
      await loadCatalog();
      const cart = await readCart();
      document.querySelectorAll('[data-kombi-notice]').forEach(notice => { notice.hidden = !allowed(cart) || hasBundle(cart) || !missingLine(cart); });
      const hint = document.querySelector('[data-kombi-shopping-hint]');
      if (hint) {
        hint.hidden = !allowed(cart) || hasBundle(cart);
        const fabric = catalog.fabricProducts[String(config.productId)];
        const link = hint.querySelector('[data-kombi-fabric-link]');
        if (link && fabric) { link.href = root + 'products/' + fabric.handle + '?variant=' + fabric.id; link.hidden = false; }
      }
    } catch {}
  };
  const intercept = async action => {
    if (busy) return;
    busy = true;
    action.button?.setAttribute('aria-busy','true');
    try {
      await loadCatalog();
      const cart = await readCart();
      if (!allowed(cart) || hasBundle(cart) || decisions[cartKey(cart)]) { resume(action); return; }
      pendingAction = action;
      showOffer(cart);
    } catch { resume(action); }
    finally { busy = false; action.button?.removeAttribute('aria-busy'); }
  };
  document.addEventListener('click',event => {
    const trigger = event.target.closest?.('[data-kombi-notice-adapter],[data-kombi-notice-skip]');
    if (trigger) {
      event.preventDefault();
      if (busy || updating) return;
      busy = true;
      Promise.all([loadCatalog(),readCart()]).then(([,cart]) => {
        currentCart = cart;
        currentLine = missingLine(cart);
        pendingAction = {kind:'click',button:checkoutButton()};
        if (trigger.hasAttribute('data-kombi-notice-skip')) { remember(cart); resume(pendingAction); return; }
        if (!allowed(cart) || !currentLine || hasBundle(cart)) { refreshHints(); return; }
        open(); showAdapters();
      }).catch(() => { trigger.closest('[data-kombi-notice]')?.querySelector('[data-kombi-notice-error]')?.replaceChildren(document.createTextNode(strings.error)); }).finally(() => { busy = false; });
      return;
    }
    const button = event.target.closest?.('#checkout,#CartDrawer-Checkout,[name="checkout"]');
    if (!button || bypass || event.defaultPrevented || button.disabled || !termsAccepted(button)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (!dialog.open) intercept({kind:'click',button});
  },true);
  document.addEventListener('submit',event => {
    if (event.target.id !== 'cart' && event.target.id !== 'CartDrawer-Form') return;
    const button = event.submitter;
    if (!button || button.name !== 'checkout' || bypass || event.defaultPrevented || !termsAccepted(button)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (!dialog.open) intercept({kind:'submit',form:event.target,button});
  },true);
  dialog.querySelector('[data-kombi-accept]').addEventListener('click',() => {
    if (currentLine) { showAdapters(); return; }
    remember(currentCart);
    window.location.assign(config.collection);
  });
  dialog.querySelectorAll('[data-kombi-skip]').forEach(button => button.addEventListener('click',() => {
    if (updating) return;
    remember(currentCart);
    close();
    const action = pendingAction; pendingAction = null;
    resume(action);
  }));
  dialog.querySelector('[data-kombi-close]').addEventListener('click',() => { if (!updating) { pendingAction = null; close(); } });
  dialog.addEventListener('cancel',event => { event.preventDefault(); if (!updating) { pendingAction = null; close(); } });
  dialog.querySelector('[data-kombi-adapter-form]').addEventListener('submit',async event => {
    event.preventDefault();
    if (updating || !event.target.reportValidity()) return;
    updating = true;
    const submit = event.target.querySelector('[type="submit"]');
    submit.disabled = true;
    dialog.querySelector('[data-kombi-error]').textContent = '';
    try {
      const choice = selectedChoice();
      const fresh = await readCart();
      const line = fresh.items.find(item => item.key === currentLine.key);
      if (!allowed(fresh) || !line || hasBundle(fresh)) throw new Error(strings.changed);
      if (Object.values(line.properties || {}).some(Boolean) || line.selling_plan_allocation) throw new Error(strings.customized);
      const product = await getJSON(root + 'products/' + choice.handle + '.js');
      if (!product.variants.some(v=>String(v.id)===choice.id && v.available)) throw new Error(strings.unavailable);
      const existing = fresh.items.filter(item => String(item.variant_id) === choice.id);
      if (existing.length > 1 || existing.some(item=>Object.values(item.properties || {}).some(Boolean) || item.selling_plan_allocation)) throw new Error(strings.changed);
      const target = existing[0];
      const updates = {[line.key]:line.quantity - 1, [target ? target.key : choice.id]:(target?.quantity || 0) + 1};
      const result = await getJSON(root + 'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
      if (!hasBundle(result)) throw new Error(strings.changed);
      remember(result);
      window.location.assign(root + 'cart');
    } catch (error) { dialog.querySelector('[data-kombi-error]').textContent = error.message || strings.error; }
    finally { updating = false; submit.disabled = false; }
  });
  const shoppingHint = document.querySelector('[data-kombi-shopping-hint]');
  if (shoppingHint) document.querySelector('#MainContent')?.prepend(shoppingHint);
  if (shoppingHint || document.querySelector('[data-kombi-notice]')) refreshHints();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refreshHints);
})();
  } catch(e) { console.error(e); }
})();

})();
